import { post } from '@/tools/http';

const loadUsers = async (ctx, ids) => {
    const now = Date.now();

    const needLoad = id => {
        const stateUser = ctx.state.users[id];

        return !stateUser || (stateUser.updatedAt + 60e3) < now;
    };

    const idsToLoad = [...new Set(ids.filter(needLoad))];

    if (!idsToLoad.length) return;

    const params = { users: idsToLoad };
    const res = await post('profile', 'user/info/list', params, true);

    ctx.commit('addUsers', res.users);
};

export default {
    namespaced: true,
    state: {
        users: {},
    },
    mutations: {
        addUsers(state, users) {
            const stateUsers = { ...state.users };

            const writeUser = user =>
                stateUsers[user.userId] = { ...user, updatedAt: Date.now() };

            users.forEach(writeUser);
            state.users = stateUsers;
        },
    },
    actions: {
        loadOne(ctx, id) {
            // noinspection JSIgnoredPromiseFromCall
            loadUsers(ctx, [id]);
        },
        loadMany(ctx, ids) {
            // noinspection JSIgnoredPromiseFromCall
            loadUsers(ctx, ids);
        },
    },
    getters: {
        byId: state => id => state.users[id],
    },
};
